require('./style.scss')
class MenuAsideDirective
  @$inject: ["warning", "User"]
  constructor: (warning, User)->                
    class MenuAside
      restrict: "C"
      template: require('./index.pug')      
      link: ($scope, $element, attrs, controller)-> 
        $scope.now = new Date();
        $scope.logout = ()->
          opts = 
            title: "Logout"
            msg: "Confirm to logout?"
          warning.warn(opts).then ()->            
            User.logout()

    return new MenuAside()

  
module.exports = MenuAsideDirective


// WEBPACK FOOTER //
// ./src/component/menu/aside/index.coffee